import { useQuery } from "@tanstack/react-query";
import { assignedAgentsQueryOptions } from "web_myplann/Api/Advisor/assignedAgentsQueryOptions";
import type { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const useAssignedAgentsQuery = (filterStatus?: UserAgentStatusEnum) =>
	useQuery(assignedAgentsQueryOptions(filterStatus));
